import React from 'react'
import "./Bbar.css";
function Bbar() {
    return (
        <div className="B-position">
           <div className="B-bar">
           ©LAVAKUMAR
            </div> 
        </div>
    )
}

export default Bbar
